// extracted by mini-css-extract-plugin
export var contents = "style-module--contents--cf0b1";
export var links = "style-module--links--f5dda";
export var title = "style-module--title--791c9";
export var wrapper = "style-module--wrapper--d851a";